import * as da from './da'
import * as de from './de'
import * as en from './en'
import * as nb from './nb'


const locales = { da, de, en, nb }

export default locales
